import http from './http'
import type {
  CodeRequestPayload,
  RegisterPayload,
  User,
  VerifyPayload,
  VerifyResult,
} from '@/types/api'

export const authService = {
  async requestCode(payload: CodeRequestPayload): Promise<void> {
    await http.post('/auth/code', payload)
  },

  async verifyCode(payload: VerifyPayload): Promise<VerifyResult> {
    const { data } = await http.post<VerifyResult>('/auth/verify', payload)
    return data
  },

  async register(payload: RegisterPayload): Promise<User> {
    const { data } = await http.post<User>('/auth/register', payload)
    return data
  },

  async me(): Promise<User> {
    const { data } = await http.get<User>('/user/me')
    return data
  },

  async logout(): Promise<void> {
    await http.post('/auth/logout')
  },

  async requestDeletionCode(): Promise<void> {
    await http.post('/user/delete-code')
  },

  async deleteAccount(code: string): Promise<void> {
    await http.post('/user/delete', { code })
  },
}
